import { createContext, useContext, useEffect, useState } from "react";

// Reduced motion follows the visitor's OS/browser setting
// (prefers-reduced-motion) — there is no manual toggle.
const MotionContext = createContext({ reduced: false, setReduced: () => {} });

const query = () =>
    typeof window !== "undefined" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export const MotionProvider = ({ children }) => {
    const [reduced, setReduced] = useState(query);

    useEffect(() => {
        const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
        const onChange = (e) => setReduced(e.matches);
        mq.addEventListener("change", onChange);
        return () => mq.removeEventListener("change", onChange);
    }, []);

    return (
        <MotionContext.Provider value={{ reduced, setReduced: () => {} }}>
            {children}
        </MotionContext.Provider>
    );
};

export const useMotion = () => useContext(MotionContext);
